import React from "react";
import classNames from "classnames";
import styles from "./verticalSeparator.css";

type SeparatorStyle = "margin-none" | "margin-around" | "margin-halfLeft" | "margin-halfRight";
interface Props {
  style?: SeparatorStyle;
  isHidden?: boolean;
}

export const VerticalSeparator = ({ style, isHidden }: Props) => (
  <div className={classNames(styles.inflex, mapStyleToClass(style))}>
    <div className={classNames(styles["vertical-separator"], isHidden && styles["hidden"])} />
  </div>
);

const mapStyleToClass = (style: SeparatorStyle = "margin-around"): string | undefined => {
  switch (style) {
    case "margin-around":
      return styles["margin-around"];
    case "margin-halfLeft":
      return styles["margin-half-left"];
    case "margin-halfRight":
      return styles["margin-half-right"];
    default:
      return;
  }
};
